import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { excluirAlert } from 'app/services/alerts';
import { vendedorApi } from 'app/services/api/vendedorApi';
import * as Actions from 'app/store/actions';
import { eventReactGA, initializeReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { VendedorTable } from './components';
import { CadastroVendedorModal } from './components/modal';
import VisualizarVendedorModal from './components/modal/VisualizarVendedorModal';
import { VendedorContext, VendedorProvider } from './VendedorContext';

const VENDEDOR = 'Vendedor';

const Vendedor = () => {
  const [, setSelecao] = useContext(VendedorContext).selecao;
  const [, setTipoSelecao] = useContext(VendedorContext).tipoSelecao;
  const [, setVendedores] = useContext(VendedorContext).vendedores;
  const [, setVendedorAtual] = useContext(VendedorContext).vendedorAtual;
  const [, setTotalElements] = useContext(VendedorContext).totalElements;
  const [page, setPage] = useContext(VendedorContext).page;
  const [size, setSize] = useContext(VendedorContext).size;
  const [loading, setLoading] = useContext(VendedorContext).loading;

  const history = useHistory();

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useReduxLoading(loading);

  const pathname = history?.location?.pathname;
  useEffect(() => {
    initializeReactGA(pathname);
  }, [pathname]);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const resetSelecao = () => {
    setSelecao([]);
    setTipoSelecao('NENHUM');
  };

  const initialPage = {
    page,
    q: '',
    size,
    sort: 'pessoa.nome,ASC',
  };

  const fetchVendedor = async (vendedorId) => {
    setLoading(true);
    try {
      const response = await vendedorApi.getOne(vendedorId);

      setVendedorAtual(response.data);
    } catch (err) {
      apiUtils.handleApiError(err);
    }
    setLoading(false);
  };

  const fetchVendedores = async (search = initialPage) => {
    setLoading(true);
    try {
      const response = await vendedorApi.get(search);

      setSelecao([]);
      setPage(response.data.number);
      setSize(response.data.size);
      setTotalElements(response.data.totalElements);
      setVendedores(response.data.content);
    } catch (err) {
      apiUtils.handleApiError(err);
    }
    setLoading(false);
  };

  const handleSubmit = async (_vendedor, pageable) => {
    let res;
    let message;

    setLoading(true);

    try {
      if (_vendedor?.id) {
        eventReactGA(VENDEDOR, 'Atualizar vendedor');
        res = await vendedorApi.put(_vendedor);
        message = 'Vendedor editado com sucesso';
      } else {
        eventReactGA(VENDEDOR, 'Cadastrar vendedor');
        res = await vendedorApi.post(_vendedor);
        message = 'Vendedor salvo com sucesso';
      }

      showSuccess(message);
      resetSelecao();
      fetchVendedores(pageable);
    } catch (err) {
      apiUtils.handleApiError(err);
    }

    setLoading(false);

    return res;
  };

  const handleDelete = (filtro) => {
    excluirAlert({
      confirmar: async () => {
        try {
          setLoading(true);
          eventReactGA(VENDEDOR, 'Excluir vendedor');
          await vendedorApi.delete({ ...filtro, ids: filtro.ids.map((c) => c.id) });
          showSuccess('Vendedor excluído com sucesso.');
          resetSelecao();
          fetchVendedores();
        } catch (error) {
          apiUtils.handleApiError(error);
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <>
      <VendedorTable fetchVendedor={fetchVendedor} fetchVendedores={fetchVendedores} onDelete={handleDelete} />
      <CadastroVendedorModal onSubmit={handleSubmit} fetchPapel={fetchVendedor} />
      <VisualizarVendedorModal />
    </>
  );
};

const VendedorContainer = () => (
  <VendedorProvider>
    <Vendedor />
  </VendedorProvider>
);

export default VendedorContainer;
